import React from "react"

import {
    Box,
    Button,
    Dialog,
    Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

interface DeleteStepProp
{
    openDialog: boolean
    onClose: () => void
    onDelete: () => void
    data: string
}
interface DeleteStepState
{
}
export class DeleteStep extends React.Component<DeleteStepProp, DeleteStepState>
{
    render()
    {
        return (
            <Dialog open={this.props.openDialog} onClose={this.props.onClose} fullWidth>
                <Typography variant="h5" sx={{ml: 2, mt: 2}}>
                    <Trans id={'workflow.delete-step.title'}>
                        Attenzione
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 2}}>
                    <Trans id={'workflow.delete-step.body'}>
                        L'operazione è irreversibile e verranno eliminate anche le azioni non ancora eseguite collegate allo step selezionato.
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 4}}>
                    <Trans>
                        Sicuro di voler eliminare lo step "{this.props.data}"?
                    </Trans>
                </Typography>
                <Box sx={{my: 2, mr: 2}} textAlign={"right"}>
                    <Button size="small"
                            onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 3,
                            }}
                            disableElevation
                    >
                        <Trans id="workflow.delete-workflow.abort">
                            Annulla
                        </Trans>
                    </Button>
                    <Button variant={"contained"}
                            disableElevation
                            sx={{
                                textTransform: "none",
                                color: "background.default",
                                bgcolor: "error.main"
                            }}
                            onClick={this.props.onDelete}
                    >
                        <Trans id="workflow.delete-workflow.delete">
                            Elimina
                        </Trans>
                    </Button>
                </Box>
            </Dialog>
        )
    }
}
